import React from 'react'
import HeaderBlock from '../../../core/components/header-block/HeaderBlock'
import { PrimaryButton, SecondaryButton } from '../../../core/components/unilink/index'
import BreadCrumbs from '../../../core/components/breadcrumbs/BreadCrumbs'
// import ProgressBar from '../../../core/components/progress-bar/ProgressBar'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import ContextFlyout from '../../../core/components/flyout/ContextFlyout'
import Box from '../../../core/components/box/Box'
import Text from '../../../core/components/typography/text/Text'
import Heading from '../../../core/components/typography/heading/Heading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import sharedKnowledge from '../../../core/img/shared-knowledge-2.png'
import './topicHeader.css'
import ic_x from '../../../core/img/ic_x.svg'

const NoProblemsFlyoutContent = () => {
  return (
    <Box paddingY={4} paddingX={4}>
      <Box marginBottom={2}>
        <Heading size='sm' color='white' fontWeight='medium'>
          Unavailable
        </Heading>
      </Box>
      <Text color='white'>
        This is in beta and has no problems.
      </Text>
    </Box>
  )
}

class TopicHeader extends React.PureComponent {
  container = null;
  constructor(props) {
    super(props)

    this.state = {
      flyoutOpen: false,
      practiceFlyoutDismissed: false,
      stickyFlyoutOpen: false,
    }

    this.practiceHoverStart = this.practiceHoverStart.bind(this)
    this.practiceHoverEnd = this.practiceHoverEnd.bind(this)
    this.stickyPracticeHoverStart = this.stickyPracticeHoverStart.bind(this)
    this.stickyPracticeHoverEnd = this.stickyPracticeHoverEnd.bind(this)
    this.practiceFlyoutDismiss = this.practiceFlyoutDismiss.bind(this)
    this.practiceTouchToggle = this.practiceTouchToggle.bind(this)
    this.stickyTouchToggle = this.stickyTouchToggle.bind(this)

  }
  componentDidUpdate() {
    if (this.props.practiceEnabled) {
      this.setState({
        flyoutOpen: false,
        stickyFlyoutOpen: false
      })
    }
  }

  // componentDidMount() {
  //   console.log(window)
  //   console.log(window.gtag)
  // }


  practiceFlyoutDismiss(e) {
    this.setState({practiceFlyoutDismissed: true})
  }
  practiceTouchToggle(e) {
    const {practiceEnabled} = this.props
    if (!practiceEnabled) {
      this.setState({flyoutOpen: !this.state.flyoutOpen})
    }
  }
  practiceHoverStart(e) {
    const {practiceEnabled} = this.props
    if (!practiceEnabled) {
      this.setState({flyoutOpen: true})
    }
  }
  practiceHoverEnd(e) {
    const {practiceEnabled} = this.props
    if (!practiceEnabled) {
      this.setState({flyoutOpen: false})
    }
  }
  stickyTouchToggle(e) {
    const {practiceEnabled} = this.props
    if (!practiceEnabled) {
      this.setState({stickyFlyoutOpen: !this.state.stickyFlyoutOpen})
    }
  }
  stickyPracticeHoverStart(e) {
    const {practiceEnabled} = this.props
    if (!practiceEnabled) {
      this.setState({stickyFlyoutOpen: true})
    }
  }
  stickyPracticeHoverEnd(e) {
    const {practiceEnabled} = this.props
    if (!practiceEnabled) {
      this.setState({stickyFlyoutOpen: false})
    }
  }
  render() {

    const safeTopics = new Set([
      4795,
      1321,
      5531,
      4322,
      4395,
      4604,
      7190,
      4408
    ])

    const underConstructionTopics = new Set([
      4106,
      752,
      4712,
      1,
      5525,
      9213,
      7587,
      7954,
      1618,
      1943
      // ,
      // 8951
    ])
    
    const betaTopics = new Set([
      10005
    ])

    const {
      title,
      breadcrumbTopics,
      id,
      description,
      practiceRemoved,
      containerRef,
      stickyHeaderEnabled,
      slug,
      isSubjectTopic,
      practiceEnabled
    } = this.props
    //const {practiceFlyoutDismissed} = this.state
    // console.log(breadcrumbTopics)
    let subjectId = null
    if (isSubjectTopic) {
      subjectId = id
    } else if (breadcrumbTopics.length) {
      subjectId = breadcrumbTopics[0].id
    }

    const safeTopic = safeTopics.has(id)
    const underConstructionTopic = underConstructionTopics.has(subjectId) || underConstructionTopics.has(id)
    const betaTopic = betaTopics.has(subjectId) || betaTopics.has(id)
    
    const headerBlockClasses = [
      'topic-header__top',
      `topic-header--${SubjectToCSSName[subjectId]}`
    ]
    const stickyHeaderClasses = [
      'topic-header__sticky-header',
      `topic-header__sticky-header--${SubjectToCSSName[subjectId]}`
    ]
    if (stickyHeaderEnabled) {
      stickyHeaderClasses.push('topic-header__sticky-header--enabled')
    }

    
    return (
      <div className="topic-header" ref={containerRef}>
        <HeaderBlock className={headerBlockClasses.join(' ')}>
          <div className="topic-header__container">
            <div className="topic-header__info">
              {
                 <div className="topic-header__breadcrumbs-container">
                  
                     <BreadCrumbs
                      breadcrumbTopics={breadcrumbTopics}
                      className="topic-header__breadcrumbs"
                    /> 
                    
                    { 
                      // underConstructionTopic || betaTopic ? 
                      // <span className={`topic-header__title-beta topic-header__title-beta--${SubjectToCSSName[subjectId]}`}>
                      //   { betaTopic ? "Beta":"Under Construction"}
                      // </span>:null
                    }
                
                  </div>
                  
              }
              {
                <div className="topic-header__title">
                  <h1>{ title }</h1>                
                </div>
              }

              <span
                className="topic-header__description"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          </div>
        </HeaderBlock>
          {
            // (underConstructionTopic && !safeTopic ) ? 
              // <div className="topic-header__under-construction-banner">
              //   <div className="gridcontainer">
              //     <div className="topic-header__under-construction-content">
              //       <div>
              //         <h2><FontAwesomeIcon className={`topic-header__uc-banner--${SubjectToCSSName[subjectId]}`} icon={['fa', 'exclamation-triangle']} />Under Construction</h2>
              //         <p>Welcome to Expii! You landed on a topic that is under construction. We are working hard to bring this topic up to our impeccable standards.</p>
              //       </div>
              //       <div><img className='' src={sharedKnowledge} alt='' /></div>
              //     </div>
              // <img src={ ic_x } alt=""/>
              //   </div>
            //   </div>:''
          }
        <div className="topic-header__bottom">
          



          <div className={stickyHeaderClasses.join(' ')}>
            <div className='gridcontainer topic-header__sticky-header__container'>
              <div
                className="topic-header__title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <div ref={node => this.sticky_practice = node}>
                {
                  (practiceRemoved || underConstructionTopic)
                    ? <PrimaryButton
                      className={`topic-header__enter-gm topic-header__enter-gm--${
                        SubjectToCSSName[subjectId]
                      }`}
                      to={slug}
                    >
                      Go to Topic
                    </PrimaryButton>
                    : <PrimaryButton
                      className={`topic-header__enter-gm topic-header__enter-gm--${
                        SubjectToCSSName[subjectId]
                      }`}
                      to={`/s/${id}`}
                      onMouseEnter={this.stickyPracticeHoverStart}
                      onMouseLeave={this.stickyPracticeHoverEnd}
                      onTouchStart={this.stickyTouchToggle}
                      disabled={!practiceEnabled}
                    >
                      Practice
                    </PrimaryButton>
                }
              </div>
            </div>
            {
              this.state.stickyFlyoutOpen &&
              <ContextFlyout
                anchor={this.sticky_practice}
                onDismiss={this.stickyPracticeHoverEnd}
                idealDirection='down'
                size='sm'
              >
                <NoProblemsFlyoutContent />
              </ContextFlyout>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default TopicHeader



// WEBPACK FOOTER //
// ./src/domains/topic/components/TopicHeader.js